import * as React from 'react';
import { Typography, Grid, Paper, Divider, Button, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  formatRecurlyPlanInterval,
  formatRecurlyPrice,
} from '../utils/formatFunctions';
import { EXT_DISTRICTPLANS } from '../../routes/CONSTANTS';

const Item = styled(Paper)(({ theme }) => ({
  maxWidth: 450,
  minWidth: 350,
  width: '25.5vw',
  padding: 0,
  margin: 5,
  borderRadius: 0,
}));

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.8rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '2.25rem',
  },
  fontWeight: 1000,
  color: '#fff',
}));

const FreeTrial = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.3rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.8rem',
  },
  fontWeight: 1000,
  color: theme.palette.tertiary.main,
}));

const Price = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.8rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '2.25rem',
  },
  fontWeight: 1000,
  color: theme.palette.text.primary,
}));

export default function PlanCard(props) {
  const {
    name,
    code,
    description,
    currencyCode,
    unitCost,
    interval,
    intervalLength,
    freeTrialInterval,
    freeTrialLength,
  } = props;

  const districtPlan = code.toLowerCase() === 'district';

  return (
    <>
      <Item elevation={5}>
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='flex-start'
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '0',
            padding: '0',
            paddingBottom: '8px',
          }}
        >
          <Grid item xs={12} sx={{ backgroundColor: 'secondary.main' }}>
            <Title>{name.toUpperCase()}</Title>
          </Grid>
          {districtPlan ? (
            <>
              <Grid item xs={12} sx={{ margin: '5px' }}>
                <Typography sx={{ fontWeight: 'bold' }}>
                  GROUP PRICING AVAILABLE
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  Must have sign up code from district to subscribe.{' '}
                  <Link
                    href={EXT_DISTRICTPLANS}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Click here
                  </Link>{' '}
                  for more information.
                </Typography>
              </Grid>
            </>
          ) : (
            <>
              {freeTrialLength > 0 && (
                <>
                  <Grid item xs={12}>
                    <FreeTrial>
                      FREE TRIAL FOR{' '}
                      {freeTrialLength + ' ' + freeTrialInterval.toUpperCase()}
                    </FreeTrial>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>THEN</Typography>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <Price>{formatRecurlyPrice(unitCost, currencyCode)}</Price>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {formatRecurlyPlanInterval(
                    interval,
                    intervalLength
                  ).toUpperCase()}
                </Typography>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sx={{ margin: '5px' }}>
            <Typography>{description}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ margin: '5px' }}>
            <Button
              color='primary'
              variant='contained'
              onClick={props.handleSelect}
            >
              Select {name}
            </Button>
          </Grid>
        </Grid>
      </Item>
    </>
  );
}
